import {
  configureStore,
  getDefaultMiddleware,
  compose,
  applyMiddleware,
} from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import { initMessageListener } from "redux-state-sync";
import createSagaMiddleWare from "redux-saga";
import { all } from "redux-saga/effects";
import rootReducer from "slices";
import globalErrorSaga from "./sagas/globalError.saga";
import globalSaga from "./sagas/global.saga";
import mapsSaga from "./sagas/maps.saga";

function* rootSaga() {
  yield all([globalErrorSaga(), globalSaga(), mapsSaga()]);
}

const sagaMiddleware = createSagaMiddleWare();
const middleware: any = [];

if (process.env.NODE_ENV !== "production") {
  middleware.push(...getDefaultMiddleware());
  //middleware.push(createLogger());
} else {
  middleware.push(
    ...getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  );
}
middleware.push(sagaMiddleware);

const store = configureStore({
  // reducer: persistedReducer,
  reducer: rootReducer,
  middleware,
  devTools: process.env.NODE_ENV !== "production",
  // enhancers: [enhancer],
});

sagaMiddleware.run(rootSaga);
initMessageListener(store);

export type GetState = typeof store.getState;
export type RootState = ReturnType<typeof store.getState>;
export type Dispatch = typeof store.dispatch;
export default store;
